// Un film uscito più di 5 anni fa viene proposto come riedizione (es. nel 2026: anno <= 2020)
export const isRiedizioneDaAnno = (anno) => {
  const a = parseInt(anno, 10);
  return a >= 1888 && a < new Date().getFullYear() - 5;
};

// Imposta Riedizione e il tipo uscita solo se mancano, senza mai togliere una scelta già fatta
export const applicaRiedizioneDaAnno = (film) => {
  if (!isRiedizioneDaAnno(film.anno)) return film;
  return { ...film, riedizione: true, tipo_uscita: film.tipo_uscita || 'Riedizione' };
};
